import { parseStepDataDTO, StepDataDTO } from './step-data-dto.js'
import { parseVariantDataDTO, VariantDataDTO } from './variant-data-dto.js'
import { parseSummaryDTO, SummaryDTO } from 'components/ordering/configurator/api/dtos/summary-dto.js'
import {
  parseStepSelectionDataRecord,
  StepSelectionData
} from 'components/ordering/configurator/api/dtos/step-selection-data.js'
import { createValidate } from 'typia'
import { validateGuard } from 'components/shared/parsing/parsing.js'

export type IMultiStepResponseDTO = {
  product: { id: number }
  summary: unknown
  completed: boolean
  steps: unknown[]
  data: unknown
  groups: Record<string, boolean>
  variant_data: unknown
  url: string | null
  additional_texts: Record<string, string>
}

export class MultiStepResponseDTO {
  product: { id: number }
  summary: SummaryDTO
  completed: boolean
  steps: StepDataDTO[]
  data: Record<string, StepSelectionData>
  groups: Record<string, boolean>
  variantData: VariantDataDTO | null
  url: string | null
  additionalTexts: Record<string, string>

  constructor(data: IMultiStepResponseDTO) {
    this.product = data.product
    this.summary = parseSummaryDTO(data.summary)
    this.completed = data.completed
    this.steps = data.steps.map(parseStepDataDTO)
    this.data = parseStepSelectionDataRecord(data.data)
    this.groups = data.groups
    this.variantData = parseVariantDataDTO(data.variant_data)
    this.url = data.url
    this.additionalTexts = data.additional_texts
  }
}

const validateMultiStepResponseDTO = createValidate<IMultiStepResponseDTO>()

export const parseMultiStepResponseDTO = (data: unknown): MultiStepResponseDTO => {
  validateGuard(validateMultiStepResponseDTO, data, 'MultiStepResponseDTO')
  return new MultiStepResponseDTO(data)
}
